<template>
  <div class="inline-flex items-center flex-grow">
    <product-badge-group :product="product" :base-properties="baseProperties" />
    <span v-if="year" class="text-sm text-gray-80" :qaid="`${qaid}modelYear`">{{ year }}</span>
  </div>
</template>
<script>
import {qaidMixin} from '@/utils/qaid-helper';
import ProductBadgeGroup from '@/components/ProductBadgeGroup';

export default {
  name: 'ProductBadgeYear',
  components: {ProductBadgeGroup},
  mixins: [qaidMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    year() {
      if (this.product.isArchived) {
        return this.product.bike ? this.product.modelYearRange : '';
      } else if (this.product.marketingModelYear && this.product.marketingModelYear.length > 0) {
        return this.product.marketingModelYear;
      }
      return '';
    },
  },
};
</script>
